/* Silky Salt Strip — theme.js
   Reveal animations, header state, menu drawer, FAQ accordions, product gallery,
   variant/offer picker, AJAX add-to-cart, and the cart drawer. No dependencies. */
(function () {
  'use strict';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(placeholderRegex);
    var type = m ? m[1] : 'amount';
    switch (type) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Reveal on scroll (.r / .r-scale) ---------- */
  function initReveal() {
    var els = $$('.r, .r-scale');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('no-reveal')) { els.forEach(function (e) { e.classList.add('v'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('v'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var nav = $('.nav');
    if (!nav) return;
    var onScroll = function () { nav.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var drawer = $('#MenuDrawer');
    if (drawer) {
      var open = function () { drawer.classList.add('is-open'); document.body.classList.add('cxc-locked'); drawer.setAttribute('aria-hidden', 'false'); };
      var close = function () { drawer.classList.remove('is-open'); document.body.classList.remove('cxc-locked'); drawer.setAttribute('aria-hidden', 'true'); };
      $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  /* ---------- FAQ accordion (.faq-item) ---------- */
  function initFaq() {
    $$('.faq-list').forEach(function (list) {
      var single = list.getAttribute('data-single') === 'true';
      $$('.faq-q', list).forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.faq-item');
          var willOpen = !item.classList.contains('open');
          if (single) $$('.faq-item.open', list).forEach(function (o) { o.classList.remove('open'); $('.faq-q', o).setAttribute('aria-expanded', 'false'); });
          item.classList.toggle('open', willOpen);
          q.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Marquee duplication safety ---------- */
  function initMarquees() {
    $$('[data-marquee-track]').forEach(function (track) {
      // Tracks are rendered twice in Liquid; if the content is still narrower than 2x viewport, clone until it is.
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 2 && guard < 6) {
        $$(':scope > *', track).slice(0, Math.max(1, track.children.length / 2)).forEach(function (c) { track.appendChild(c.cloneNode(true)); });
        guard++;
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    root: null, items: null, title: null, subtotal: null, count: null, err: null, discApplied: null,
    init: function () {
      this.root = $('#CartDrawer');
      this.count = $$('[data-cart-count]');
      if (this.root) {
        this.items = $('[data-cart-items]', this.root);
        this.title = $('[data-cart-title]', this.root);
        this.subtotal = $('[data-cart-subtotal]', this.root);
        this.err = $('[data-cart-error]', this.root);
        this.discApplied = $('[data-cart-discounts]', this.root);
        var self = this;
        $$('[data-cart-close]', this.root).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.root.classList.contains('cxc--open')) self.close(); });
        var applyBtn = $('[data-discount-apply]', this.root);
        if (applyBtn) applyBtn.addEventListener('click', function () { self.applyDiscount(); });
        var discInput = $('[data-discount-input]', this.root);
        if (discInput) discInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.applyDiscount(); } });
        this.items.addEventListener('click', function (e) { self.onItemClick(e); });
      }
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (window.theme && window.theme.cartType === 'drawer' && self && self.root) { e.preventDefault(); self.open(true); }
        });
      });
      var self2 = this;
      // Cart page quantity controls reuse the same markup
      $$('[data-cart-page-items]').forEach(function (wrap) { wrap.addEventListener('click', function (e) { self2.onItemClick(e, true); }); });
    },
    open: function (refresh) {
      if (!this.root) { window.location.href = routes.cart_url || '/cart'; return; }
      this.root.classList.add('cxc--open'); this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cxc-locked'); document.body.classList.add('cxc-locked');
      if (refresh !== false) this.refresh();
    },
    close: function () {
      if (!this.root) return;
      this.root.classList.remove('cxc--open'); this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cxc-locked'); document.body.classList.remove('cxc-locked');
    },
    fetch: function () { return fetch((routes.cart_url || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); },
    refresh: function () { var self = this; return this.fetch().then(function (cart) { self.render(cart); return cart; }); },
    setLoading: function (on) { if (this.root) this.root.classList.toggle('is-loading', !!on); },
    render: function (cart) {
      var self = this;
      this.count.forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      if (!this.root) return;
      if (this.title) this.title.textContent = this.title.getAttribute('data-label') + ' (' + cart.item_count + ')';
      if (this.subtotal) this.subtotal.textContent = formatMoney(cart.items_subtotal_price);
      if (this.discApplied) {
        this.discApplied.innerHTML = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) {
          return '<span class="cxc__disc-pill">' + escapeHtml(d.code) + '</span>';
        }).join('');
      }
      if (!cart.items.length) {
        this.items.innerHTML = '<div class="cxc__empty">' + escapeHtml(this.items.getAttribute('data-empty')) + '<br><a class="btn btn--sm" href="' + escapeHtml(this.items.getAttribute('data-shop-url') || '/collections/all') + '">' + escapeHtml(this.items.getAttribute('data-shop-label') || 'Shop') + '</a></div>';
        var ft = $('[data-cart-footer]', this.root); if (ft) ft.hidden = true;
        return;
      }
      var ft2 = $('[data-cart-footer]', this.root); if (ft2) ft2.hidden = false;
      this.items.innerHTML = cart.items.map(function (it, idx) { return self.itemHtml(it, idx + 1); }).join('');
    },
    itemHtml: function (it, line) {
      var img = it.featured_image && it.featured_image.url ? it.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var compare = it.original_line_price > it.final_line_price ? '<span class="cxc-price__compare">' + formatMoney(it.original_line_price) + '</span>' : '';
      var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; }).map(function (o) { return '<div>' + escapeHtml(o.name) + ': ' + escapeHtml(o.value) + '</div>'; }).join('');
      var plan = it.selling_plan_allocation ? '<div>' + escapeHtml(it.selling_plan_allocation.selling_plan.name) + '</div>' : '';
      return '<div class="cxc-item" data-line="' + line + '" data-key="' + escapeHtml(it.key) + '">' +
        '<div class="cxc-item__grid">' +
          '<div class="cxc-item__tile">' + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(it.product_title) + '" loading="lazy">' : '') + '</div>' +
          '<div class="cxc-item__main">' +
            '<div class="cxc-item__top"><a class="cxc-item__title" href="' + escapeHtml(it.url) + '">' + escapeHtml(it.product_title) + '</a>' +
              '<button class="cxc-item__trash" type="button" aria-label="Remove" data-remove><svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2m2 0v14a1 1 0 01-1 1H7a1 1 0 01-1-1V6"/><path d="M10 11v6M14 11v6"/></svg></button></div>' +
            '<div class="cxc-item__meta">' + opts + plan + '</div>' +
            '<div class="cxc-item__row">' +
              '<div class="cxc-qty"><button type="button" data-qty="-1" aria-label="Decrease"' + (it.quantity <= 1 ? '' : '') + '>&minus;</button><span class="cxc-qty__n">' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>' +
              '<div class="cxc-price"><span class="cxc-price__line">' + compare + ' <span class="cxc-price__sale">' + formatMoney(it.final_line_price) + '</span></span></div>' +
            '</div>' +
          '</div>' +
        '</div></div>';
    },
    onItemClick: function (e, isPage) {
      var btn = e.target.closest('button'); if (!btn) return;
      var item = btn.closest('.cxc-item'); if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var qtyEl = $('.cxc-qty__n', item);
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      var next = null;
      if (btn.hasAttribute('data-remove')) next = 0;
      else if (btn.hasAttribute('data-qty')) next = Math.max(0, qty + parseInt(btn.getAttribute('data-qty'), 10));
      if (next === null) return;
      this.change(line, next, isPage);
    },
    change: function (line, quantity, isPage) {
      var self = this; this.setLoading(true);
      return fetch(routes.cart_change_url || '/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.setLoading(false); if (isPage) { window.location.reload(); } else { self.render(cart); } })
        .catch(function () { self.setLoading(false); if (self.err) self.err.textContent = strings.cartError || 'Something went wrong.'; });
    },
    add: function (formData) {
      var self = this; this.setLoading(true);
      return fetch(routes.cart_add_url || '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: formData })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { self.setLoading(false); if (window.theme && window.theme.cartType === 'drawer' && self.root) { self.open(true); } else { window.location.href = routes.cart_url || '/cart'; } });
    },
    applyDiscount: function () {
      var input = $('[data-discount-input]', this.root); if (!input || !input.value.trim()) return;
      var self = this; this.setLoading(true);
      fetch(routes.cart_update_url || '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: input.value.trim() }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.setLoading(false);
          var ok = (cart.discount_codes || []).some(function (d) { return d.applicable && d.code.toLowerCase() === input.value.trim().toLowerCase(); });
          if (self.err) self.err.textContent = ok ? '' : (self.root.getAttribute('data-discount-invalid') || 'That code could not be applied.');
          if (ok) input.value = '';
          self.render(cart);
        })
        .catch(function () { self.setLoading(false); if (self.err) self.err.textContent = strings.cartError || 'Something went wrong.'; });
    }
  };

  /* ---------- Product form: gallery, variants, qty, add ---------- */
  function initProduct(root) {
    var data = $('[data-product-json]', root);
    if (!data) return;
    var product = JSON.parse(data.textContent);
    var form = $('form[data-product-form]', root);
    var idInput = $('input[name="id"]', form);
    var cta = $('[data-add-button]', form);
    var ctaLabel = cta ? $('[data-add-label]', cta) : null;
    var priceEl = $('[data-product-price]', root);
    var compareEl = $('[data-product-compare]', root);
    var errEl = $('[data-product-error]', root);
    var qtyInput = $('[data-qty-input]', root);

    // Gallery
    var frames = $$('[data-media]', root);
    var thumbs = $$('[data-thumb]', root);
    var current = 0;
    function show(i) {
      if (!frames.length) return;
      current = (i + frames.length) % frames.length;
      frames.forEach(function (f, k) { f.classList.toggle('is-active', k === current); var v = f.tagName === 'VIDEO' ? f : $('video', f); if (v) { if (k === current) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } } });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === current); if (k === current && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {} } });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    if (frames.length <= 1) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
    // Touch swipe
    var frame = $('[data-gallery-frame]', root), sx = 0;
    if (frame) { frame.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true }); frame.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1); }, { passive: true }); }

    // Variant selection
    var optionInputs = $$('[data-option-input]', root);
    function selectedOptions() {
      var opts = [];
      product.options.forEach(function (name, idx) {
        var checked = $$('[data-option-input][data-option-index="' + idx + '"]', root).filter(function (i) { return i.tagName === 'SELECT' ? true : i.checked; })[0];
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function updateAvailability(opts) {
      // mark option cards unavailable when no variant with that value (given other selections) exists
      $$('[data-option-card]', root).forEach(function (card) {
        var idx = parseInt(card.getAttribute('data-option-index'), 10), val = card.getAttribute('data-option-value');
        var test = opts.slice(); test[idx] = val;
        var v = findVariant(test);
        card.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function applyVariant(v) {
      if (!v) {
        if (cta) { cta.disabled = true; if (ctaLabel) ctaLabel.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (cta) { cta.disabled = !v.available; if (ctaLabel) ctaLabel.textContent = v.available ? (cta.getAttribute('data-label-add') || strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out'); }
      if (v.featured_media && v.featured_media.id) { var idx = frames.findIndex(function (f) { return String(f.getAttribute('data-media-id')) === String(v.featured_media.id); }); if (idx >= 0) show(idx); }
      $$('[data-option-card]', root).forEach(function (card) { var idx2 = parseInt(card.getAttribute('data-option-index'), 10); card.classList.toggle('is-sel', card.getAttribute('data-option-value') === v.options[idx2]); });
      if (history.replaceState) { try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString()); } catch (e) {} }
    }
    optionInputs.forEach(function (inp) { inp.addEventListener('change', function () { var opts = selectedOptions(); updateAvailability(opts); applyVariant(findVariant(opts)); }); });
    if (product.variants.length > 1) { var o0 = selectedOptions(); updateAvailability(o0); applyVariant(findVariant(o0)); }

    // Quantity
    $$('[data-qty-change]', root).forEach(function (b) { b.addEventListener('click', function () { if (!qtyInput) return; var n = parseInt(qtyInput.value || '1', 10) + parseInt(b.getAttribute('data-qty-change'), 10); qtyInput.value = Math.max(1, n); }); });

    // Submit
    if (form) form.addEventListener('submit', function (e) {
      if (!(window.theme && window.theme.cartType === 'drawer')) return; // normal submit → cart page
      e.preventDefault();
      if (errEl) { errEl.textContent = ''; errEl.classList.remove('is-visible'); }
      if (cta) { cta.disabled = true; cta.classList.add('is-loading'); }
      var fd = new FormData(form);
      Cart.add(fd).then(function () { if (cta) { cta.disabled = false; cta.classList.remove('is-loading'); } })
        .catch(function (err) { if (cta) { cta.disabled = false; cta.classList.remove('is-loading'); } if (errEl) { errEl.textContent = (err && (err.description || err.message)) || strings.cartError || 'Something went wrong.'; errEl.classList.add('is-visible'); } });
    });
  }

  /* ---------- Quick add from product cards ---------- */
  function initQuickAdd() {
    $$('form[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!(window.theme && window.theme.cartType === 'drawer')) return;
        e.preventDefault();
        var btn = $('button[type="submit"]', form); if (btn) btn.disabled = true;
        Cart.add(new FormData(form)).then(function () { if (btn) btn.disabled = false; }).catch(function () { if (btn) btn.disabled = false; window.location.href = routes.cart_url || '/cart'; });
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initCollectionTools() {
    var sel = $('[data-sort-by]'); if (!sel) return;
    sel.addEventListener('change', function () { var url = new URL(window.location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page'); window.location.href = url.toString(); });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initReveal(); initHeader(); initFaq(); initMarquees(); Cart.init(); initQuickAdd(); initCollectionTools();
    $$('[data-product-root]').forEach(initProduct);
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () { initReveal(); initFaq(); initMarquees(); $$('[data-product-root]').forEach(initProduct); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.SSCart = Cart;
})();
